export const user = {
  button_change_password: "Change password",
  pw_change_popup_head: "Change Password",
  pw_change_popup_response: "Your password is now changed.",
  pw_change_error: "We where unable to change your password.",

  trigger_email_verification_response_head: "Email Verification",
  trigger_email_verification_response:
    "If the email address was found, an email has now been sent with an verification link.",

  trigger_email_verification_error:
    "Unable to send an email verification link at this time, please tryg again later",

  change_password_head: "Change Password",
  change_password:
    "Change your password by submitting your current password and the new password you would like to have.",

  set_password_head: "Set Password",
  set_password:
    "You do not have a password set. Click the button below to request a password link to be sent to your email address %s.",
  button_get_password_link: "Request password link",

  change_email_head: "Change email address",
  change_email:
    "Input the email address you would like to change to. An verification email will be sent out where you need to verify within 24 hours.",
  current_email: "Current email address: ",
  awaiting_verification: "Awaiting verification: ",
  new_email_address: "New email address",
  button_change_email: "Change email",
  email_change_error_in_use: "Email already in use",
  email_change_popup_head: "Change Email",
  email_change_popup_response:
    "A verification email has been sent to your new email address. Please verify within 24 hours.",
  email_change_error: "We where unable to change your email.",
};
